// extracted by mini-css-extract-plugin
export default {"icon":"CallOpt_icon__Vx13E","placeHolderShimmer":"CallOpt_placeHolderShimmer__G2A+L"};